import { FC, useRef } from "react";
import {
    Box,
    Button,
    Drawer,
    DrawerBody,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    useDisclosure,
    IconButton,
    StyleProps,
    Flex,
    VStack,
    useColorModeValue,
} from "@chakra-ui/react";

import { Link as RouterLink, useLocation } from "react-router-dom";

import { ColorModeButton } from "shared/color-mode-button/ColorModeButton";
import { MenuIcon } from "utils/Icons";
import { Socials } from "shared/socials/Socials";
import { onResumeOpen } from "utils/Functions";

interface Props extends StyleProps {}

export const MenuDrawer: FC<Props> = ({ ...props }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const btnRef = useRef<any>(null);
    const navItemColor = useColorModeValue("gray.800", "white");
    const location = useLocation();

    const navLinks = [
        { label: "Home", to: "/" },
        { label: "Services", to: "/services" },
        { label: "Featured Work", to: "/work" },
        { label: "Articles & Media", to: "/media" },
        { label: "Contact", to: "/contact" },
        { label: "About", to: "/about" },
        { label: "Professional Summary", to: "/summary" },
        { label: "Resume", to: "/resume" }
        
    ];
    return (
        <Box {...props}>
            <Button
                as={IconButton}
                variant="icon"
                ref={btnRef}
                onClick={onOpen}
                aria-label="open drawer"
                fontSize="lg"
                color="primary.500"
                icon={<MenuIcon />}
                px="0"
            />
            <Drawer isOpen={isOpen} placement="right" onClose={onClose} autoFocus={false}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerHeader px="4">
                        <Flex justifyContent="space-between">
                            <ColorModeButton />
                            <DrawerCloseButton position="relative" top="0" right="0" />
                        </Flex>
                    </DrawerHeader>

                    <DrawerBody>
                        <VStack spacing="6" my="16">
                            {navLinks.map((link, index) => (
                                <Button
                                    key={link.to}
                                    as={RouterLink}
                                    to={link.to}
                                    onClick={onClose}
                                    variant="link"
                                    color={navItemColor}
                                    textDecoration={location.pathname === link.to ? "underline" : "none"}
                                    textDecorationThickness="2px"
                                    textDecorationColor="primary.500"
                                    data-aos="fade"
                                    data-aos-delay={200 + index * 100}
                                    fontWeight="600"
                                    fontSize="2xl"
                                >
                                    {link.label}
                                </Button>
                            ))}
                           
                        </VStack>
                        <Flex justifyContent="center" mt="16">
                            <Socials delay={100} resume={false} exclude={["github" , "mail"]}/>
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </Box>
    );
};
